import AdresseFields from "./felter/AdresseFields";
import BankkodeField from "./felter/BankkodeField";

const AmerikanskKonto = () => {
    return (
        <>
            <BankkodeField />
            <AdresseFields />
        </>
    );
};

export default AmerikanskKonto;
